    /* eslint-disable */
  import axios from "axios";
  import store from "@/store";
  import VPagination from "@hennge/vue3-pagination";
  import Multiselect from "@vueform/multiselect";
  import customModal  from "../customModal/customModal.vue"; 
  import moment from "moment";
  import { isElementAccessExpression } from "typescript";
    import { toHandlers } from "vue";
  export default {
    name: "analysisTreeQC",
    components: {
      customModal,
      Multiselect,
      VPagination
    },
    data() {
      return {
        headingId:"",
        editType:"",  
        initialLoader:true,
        loading:true,
        studyId: "",
        studyref:"",
        foldername: "Adam_set",
        baseUrl: process.env.VUE_APP_Service_URL,
        showTree: false,
        displayProgramModal:false,
        loadingBlock:[false],
        treeData: [],
        treeModal:[],
        programList:[],
        showLoading: false,
        tocId: "",
        mapValue:[],
        idSet:[],
        tocid:"",
        resultData: [],
        getCode:[],
        resultViewData: "",
        displayModal: false,
        headerValues: {},
        openSettings:false,
        mapProgrammePopup :false,
        displayProgramComparison:false,
        initialRunLoader:false,
        setProgram:false,
        compareProgram:false,
        displayRun:false,
        displayOutput:false,
        isReady:false,
        selectedChildren:[],
        childrenChecked: {},
        subchildrenChecked:{},
        clickedTab: "",
        refreshFlags: [],
        files: [],
        userList:[],
        htmlContent: {},
        headingname:"",
        headindex:"",
        activeTab: null,
        reportid:"",
        editreportid:"",
        tocHeading:"",
        editheadingid:"",
        tocid:"",
        subreport:"",      
        mapId:"",
        modalChildLabels:{},
        rootChecked: {},
        childrenChecked: {}, 
        object1:{},
        object2:{},
        iframeRefs: {} ,
        modalTocId:"",
        activeTab: null,
        programme: [],
        values:[],
        usersValues:[],
        reportType:[],
        checkedNodes: JSON.parse(localStorage.getItem("checkedNodes")) || {}, 
        status:"",
        changedStatus:"",
        programmer:"",
        usersList:[],
        assignedValue:false,
        showGenerateBtn:false,
        initialTreeLoader:false,
        selectedVersionTrueId:[],
        defaultdate:"",
        programmerCount:"",
        developmentCount:"",
        selectedReportSourceId:"",
        readyForValidation:"",
        validated:"",
        currentOutput:"",
        oldOutput:"",
        noOutput:"",
        lastStatus:"",
        activeBadge:null,
        headerNames:[],
        selectedPrograms:[],
        selectedProgramsId:[],
        childLabels:{},
        selectedHeadingId:"",
        oldReportName:"",
        newReportName:"",
        selectedUpdateOption:"",
        defaultDate:"",
        defaultTime:"",
        selectedBranchType:"",
        selectedValidationType:[],
        listProgramRunStatus:[],
        showStatusLoading:[],
        versionList:[],
        errorMapper:false,
        createVersionModal:false,
        statusComments:"",
        interimSelectedVersion:"",
        interimVersion:"",
        interimComments:"",
        pageSize:10,
        totalPages:1,
        showClearLoading:false,
        showProgramLoading:false,
        selectedProgramIds: [],
        rootChecked: {},
        childrenChecked: {},
        subchildrenChecked: {},
      };
      
    },
    watch: {
      showButton: {
        immediate: true, // Run the watcher immediately on load
        handler() {
          this.isReady = true;
        }
      }
    },
    computed: {
      formattedUsersList() {
        return this.usersList.map(user => ({
          ...user,
          fullName: `${user.firstName} ${user.lastName}`
        }));
      },
      // filteredTreeData() {
      //   if (!this.values.length) return this.treeData; // Show all if no filters
      
      //   let filtered = {};
      
      //   Object.keys(this.treeData).forEach((key) => {
      //     let node = this.treeData[key];
      
      //     // Filter reports based on multiple selected filter properties
      //     let filteredReports = node.Reports.filter((report) => {
      //         let reportValue = this.getReportStatus("reportType", report.Reportid); // Fetch dynamic property
      //           return this.values.includes(reportValue);
              
      //       });
      //       if (filteredReports.length > 0) {
      //         filtered[key] = { ...node, Reports: filteredReports };
      //       }
      //     });
      
      //     // Add nodes with matching reports
      
      //   return filtered;
      // }
      
    },
    async mounted() {
      this.expandAll=true,
      this.expandSections=true,
      this.collapseAll= true,
      this.initialTreeLoader=true
      this.token = store.getters.getIdToken;
      this.interimVersion=store.getters.getVersion
      this.interimSelectedVersion=this.interimVersion
      this.headerValue = {
        headers: {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        },
      }
      this.studyId = store.getters.getStudyIs;
      const cachedTreeData = store.getters.getTreeData;
      if (cachedTreeData && cachedTreeData.length > 0) {
        this.treeData = cachedTreeData;
        this.treeModal=cachedTreeData
        this.showTree = true;

  
      }
      await this.getVersion()
      await this.getstudyinfo();
      await this.fetchToC('','');
      await this.getUsersList()
      if(this.treeData.length!=0){
       this.headingList= this.treeData.map(header => ({
          ...header,
          label: `${header.Headingname}`,
          value: `${header.Headingname}`
        }));
        // await this.getMappings()
        // await this.getCounts()
        // this.getOutputCounts()
      }
   
      window.addEventListener("studyIdChanged", async () => {
        this.studyId = store.getters.getStudyIs;
        this.showGenerateBtn=false
        this.initialTreeLoader=true
        await this.getVersion()
        await this.fetchToC();
        await this.getstudyinfo();
      });
    },
    methods: {    
      async fetchToC() {
        const idtoken = store.getters.getIdToken;
         await axios.post(
            `${this.baseUrl}/stats-python/toc/gettocwithprogram`,            
            {
                "StudyId": this.studyId,
                "TocId": "",
                "HeadingName": this.headerNames,
                "HasOutput":true,
                "IsSelectedVersion": true,                
                "ReportId": "",
                "ReportName": "",
                "Version": "",
                "TocDescription": "",
                "ReportType": this.reportType,
                "DeveloperName": this.usersValues,
                "QCName":[],
                "Status":"Validated",
                "ProgramId": "",
                "ProgramName": [],
                "HasProgram": null,
                "InterimVersion":this.interimSelectedVersion,
                "Checkqc":true

            },
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res)=>{
            if (res.data.result.toc_data) {
              this.tocid =  res.data.result._id;
              this.treeData = res.data.result.toc_data || [];
              this.treeModal=res.data.result.toc_data || [];
              this.showTree = true;
              this.tocHeading = this.$t("navigations.analysis tree")
    
              this.showLoading = false;
              this.showFilterBtn=true
              this.initialTreeLoader=false             
              store.dispatch("setTocGenerateBtn", true);
            } else {
              console.warn("Study ID does not exist or is invalid.");
              this.tocHeading = this.$t("navigations.toc generate")
              this.treeData = [];
              this.treeModal=[]
              this.initialTreeLoader=false
              this.showTree = false;
            }
          
          })
         .catch((error)=> {
          this.tocHeading = this.$t("navigations.toc generate")
          this.initialTreeLoader=false
          console.error("Error in ID check API call:", error);
          this.treeData = [];
          this.treeModal=[]
          this.showTree = false;
        })
      },
      getBadgeClass(status,output,type) {
        if(type=='status'){
          const badgeClasses = {
            // "No Output": output == false ? "custom-badge badge-black rounded-radius":'',
            // "No Program": "custom-badge badge-black status-b-radius",
            // "Old Output": output == false ? "custom-badge badge-danger rounded-radius":'',
            // "Ready For Validation": "custom-badge badge-danger status-b-radius",
            // "In Development": "custom-badge badge-yellow status-b-radius",
            // "Current Output": "custom-badge badge-orange rounded-radius status-b-radius",
            "Validated": "custom-badge badge-grn status-b-radius"
          };
          return badgeClasses[status] || "badge badge-default"; // Default class if status is unknown
        }
        else{
          const badgeClasses = {
          "No Output": output == false ? "custom-badge badge-black rounded-radius mr-1": output == true ? "custom-badge badge-danger rounded-radius mr-1":'',
          "No Program": "custom-badge badge-black",
          "Old Output": output == false ? "custom-badge badge-danger rounded-radius mr-1":output == true ? "custom-badge badge-danger rounded-radius mr-1":'',
          "Ready For Validation":output == false ? "custom-badge badge-black rounded-radius mr-1":output == true ? "custom-badge badge-danger rounded-radius mr-1":'',
          "In Development": output == false ? "custom-badge badge-black rounded-radius mr-1":output == true ? "custom-badge badge-danger rounded-radius mr-1":'',
          "Current Output": "custom-badge badge-orange rounded-radius",
          "Validated": output == false ? "custom-badge badge-black rounded-radius mr-1":output == true ? "custom-badge badge-danger rounded-radius mr-1":'',
          }
          return badgeClasses[status] || "badge badge-default"; // Default class if status is unknown
        }
       
        
      },
      async getstudyinfo() {
        const idtoken = store.getters.getIdToken;
            await axios
          .get(
            `${this.baseUrl}/management/study/getbyid?id=${store.getters.getStudyIs}&api-version=1.0`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.studyInfo = res.data;
            this.studyref = res.data.studyRef
          })
          .catch((err) => {
            console.log(err);
          });
      },
      async getUsersList() {
        const idtoken = store.getters.getIdToken;
            await axios
          .get(
            `${this.baseUrl}/account-core/user/getstudybasedusers?studyid=${store.getters.getStudyIs}&api-version=1.0`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.usersList = res.data.entities;
          })
          .catch((err) => {
            console.log(err);
          });
      },
      setVersionNo(){
        this.initialTreeLoader=true
        store.dispatch("setVersion",this.interimVersion)
        this.interimSelectedVersion=this.interimVersion
        this.fetchToC();
      },
      async getVersion(){
        const idtoken = store.getters.getIdToken;
         await axios.get(
          `${this.baseUrl}/forms/cdisc/listinterimversions?studyId=${this.studyId}`,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        ).then((res)=>{
            this.versionList = res.data
                    
        }).catch((err)=>{
          console.log("err",err)
        })
      },
      toggleChildren(node, nodeIndex, rootId) {
        const isChecked = this.rootChecked[rootId];
    
        node.Reports.forEach((child, reportIndex) => {
          const childId = `treeData-${nodeIndex}-${reportIndex}`;
          if (isChecked) {
            this.childrenChecked[childId] = true;
    
            child.Programms.forEach((program, subIndex) => {
              const subId = `treeData-${nodeIndex}-${reportIndex}-${subIndex}`;
              this.subchildrenChecked[subId] = true;
    
              if (program._id) this.selectedProgramIds.push(program._id);
            });
          } else {
            delete this.childrenChecked[childId];
    
            child.Programms.forEach((program, subIndex) => {
              const subId = `treeData-${nodeIndex}-${reportIndex}-${subIndex}`;
              delete this.subchildrenChecked[subId];
    
              this.selectedProgramIds = this.selectedProgramIds.filter(id => id !== program._id);
            });
          }
        });
    
        this.selectedProgramIds = [...new Set(this.selectedProgramIds)];
        console.log("Selected program ids are", this.selectedProgramIds);
      },    
      toggleChild(reportsArray, nodeIndex, childIndex, isChecked) {
        const childId = `treeData-${nodeIndex}-${childIndex}`;
        const child = reportsArray[childIndex];
      
        if (isChecked) {
          this.childrenChecked[childId] = true;
      
          child.Programms.forEach((program, subIndex) => {
            const subId = `treeData-${nodeIndex}-${childIndex}-${subIndex}`;
            this.subchildrenChecked[subId] = true;
      
            if (program._id) this.selectedProgramIds.push(program._id);
          });
        } else {
          delete this.childrenChecked[childId];
      
          child.Programms.forEach((program, subIndex) => {
            const subId = `treeData-${nodeIndex}-${childIndex}-${subIndex}`;
            delete this.subchildrenChecked[subId];
      
            this.selectedProgramIds = this.selectedProgramIds.filter(id => id !== program._id);
          });
        }
      
        this.selectedProgramIds = [...new Set(this.selectedProgramIds)];
        console.log("Selected program ids are", this.selectedProgramIds);
      },    
      toggleSubChild(nodeIndex, childIndex, subIndex, isChecked, program) {
        const subId = `treeData-${nodeIndex}-${childIndex}-${subIndex}`;
    
        if (isChecked) {
          this.subchildrenChecked[subId] = true;
          if (program._id) this.selectedProgramIds.push(program._id);
        } else {
          delete this.subchildrenChecked[subId];
          this.selectedProgramIds = this.selectedProgramIds.filter(id => id !== program._id);
        }
    
        this.selectedProgramIds = [...new Set(this.selectedProgramIds)];
        console.log("Selected program ids are", this.selectedProgramIds);
      },
      async saveProgramIds(){
        this.showProgramLoading=true
        const idtoken = store.getters.getIdToken;
        if(this.selectedProgramIds.length==null || this.selectedProgramIds==undefined){
          this.showProgramLoading=false
          alert(this.$t("navigations.please select atlease one program id"))
          
        }
        else{
          await axios
          .put(
            `${this.baseUrl}/stats-python/programme/changestatqcstatus`,
            {
              "Status": true,
              "ProgramId":this.selectedProgramIds
            },
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.showProgramLoading=false
            alert(this.$t("navigations.stat qced successfully"))
            this.fetchToC()
          })
          .catch((err)=>{
            this.showProgramLoading=false
            console.log(err)
          })
        }        
      }
    }
  }
  